import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Logo from "../images/logo.png";
import { RiArrowGoBackLine } from 'react-icons/ri';
import { buildApiUrl } from "../utils/api";

function MarketerLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(buildApiUrl('/api/marketer/login'), { email, password });
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userType', 'Marketer');
            navigate('/marketerDetails');
        } catch (err) {
            setError('Invalid credentials. Please check your email and password.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>CS Agent Login | 3PL Search</title>
            </Helmet>
            <div className="marketerloginPage d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "100vh", background: "#f3f7fb" }}>
                <img src={Logo} alt="logo" style={{ height: "64px", marginBottom: "1.5rem" }} />

                <form
                    onSubmit={handleLogin}
                    style={{
                        background: "#fff",
                        borderRadius: "12px",
                        padding: "2.5rem",
                        width: "100%",
                        maxWidth: "420px",
                        boxShadow: "0 8px 32px rgba(19,34,56,0.1)"
                    }}
                >
                    <h2 className="text-center mb-1" style={{ color: "#132238", fontWeight: 800 }}>CS Agent Login</h2>
                    <p className="text-center text-muted mb-4" style={{ fontSize: "0.9rem" }}>Manage enquiries, quotes, and buyer briefs.</p>

                    {error && <div className="alert alert-danger py-2" role="alert">{error}</div>}

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="agent@company.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="email"
                        />
                    </div>

                    <div className="mb-4">
                        <label className="form-label fw-semibold">Password</label>
                        <div className="input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                tabIndex={-1}
                                onClick={() => setShowPassword(s => !s)}
                            >
                                {showPassword ? "Hide" : "Show"}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="btn btn-primary w-100 py-2 fw-bold" disabled={loading}>
                        {loading ? "Signing in..." : "Sign in"}
                    </button>

                    <div className="text-center mt-3">
                        <p className="small mb-1">
                            New CS agent? <Link to="/registerMarketer">Create account</Link>
                        </p>
                        <Link to="/" style={{ color: "#5a6f86", fontSize: "0.85rem" }}>
                            <RiArrowGoBackLine /> Back to home
                        </Link>
                    </div>
                </form>
            </div>
        </>
    );
}

export default MarketerLogin;
